import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-background text-center text-foreground" aria-label="Limited time offer" data-id="element-217" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-primary" aria-hidden="true" data-id="element-218" data-mp="36bimxjk5vlee" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-219" data-mp="31iz9cmlh4q9l">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-accent" data-id="element-220" data-mp="31h4rxi9evga9">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-221" data-mp="3b910xod1cqt9" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-222" data-mp="3p8tpbd13auy2" />
        <p className="mt-7 font-bold text-muted" data-id="element-223" data-mp="3p7s7mppkja7d">After that the price increases and never drops again.</p>
      </div>
      <div className="h-1 w-full bg-primary" aria-hidden="true" data-id="element-224" data-mp="3l7q6chnqwism" />
    </section>;
}